import { createBrowserRouter, redirect } from 'react-router-dom';
import React from 'react';
import { getCurrentUser } from '../util/auth';
import SignUpPage from '../pages/sign-up';
import LoginPage from '../pages/login';
import HomePage from '../pages/home';
import TabRouter from '../components/TabRouter';
import ProfilePage from '../pages/profile';
import StudentsPage from '../pages/students';
import PaymentPage from '../pages/payment';
import StudentPage from '../pages/student/StudentPage';
import ForgotPasswordPage from '../pages/forgot-password';
import ResetPasswordPage from '../pages/reset-password';
import RequireInstructor from '../components/RequireInstructor';
import { getUser } from '../hooks/api/user';

const checkIsLoggedIn = () => {
  const user = getCurrentUser();
  if (!user) {
    return redirect('/login');
  }
  return null;
};

const checkIsAdmin = async () => {
  const currentUser = getCurrentUser();
  if (!currentUser) {
    return redirect('/login');
  }

  const currentUserId = Number(currentUser.sub);
  if (Number.isNaN(currentUserId)) {
    return redirect('/login');
  }

  try {
    const user = await getUser(currentUserId);

    if (!user.instructor) {
      return redirect('/home');
    }
  } catch {
    return redirect('/home');
  }

  return null;
};

const checkIsNotLoggedIin = ({ request }: { request: Request }) => {
  const user = getCurrentUser();
  const url = new URL(request.url);
  const addAccount = url.searchParams.get('addAccount');

  if (user && !addAccount) {
    return redirect('/home');
  }
  return null;
};

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <TabRouter>
        <HomePage />
      </TabRouter>
    ),
    loader: checkIsLoggedIn,
  },
  {
    path: '/sign-up',
    element: <SignUpPage />,
    loader: checkIsNotLoggedIin,
  },
  {
    path: '/login',
    element: <LoginPage />,
    loader: checkIsNotLoggedIin,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
    loader: checkIsNotLoggedIin,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
    loader: checkIsNotLoggedIin,
  },
  {
    path: '/home',
    element: (
      <TabRouter>
        <HomePage />
      </TabRouter>
    ),
    loader: checkIsLoggedIn,
  },
  {
    path: '/profile',
    element: (
      <TabRouter>
        <ProfilePage />
      </TabRouter>
    ),
    loader: checkIsLoggedIn,
  },
  {
    path: '/payment',
    element: (
      <TabRouter>
        <PaymentPage />
      </TabRouter>
    ),
    loader: checkIsLoggedIn,
  },
  {
    path: '/students',
    element: (
      <TabRouter>
        <RequireInstructor>
          <StudentsPage />
        </RequireInstructor>
      </TabRouter>
    ),
    loader: checkIsAdmin,
  },
  {
    path: '/students/:id',
    element: (
      <TabRouter>
        <RequireInstructor>
          <StudentPage />
        </RequireInstructor>
      </TabRouter>
    ),
    loader: checkIsAdmin,
  },
]);
export default router;
